export default {
  columns: {
    userId: "ユーザーID",
    storeName: "ストア名",
    edit: "編集",
  },

  btn: {
    addUser: "ユーザーの新規登録",
    deleteUser: "ユーザー削除",
    search: "検索",
  },

  status: {
    active: "アクティブ",
    inactive: "非アクティブ",
  },

  role: {
    superAdmin: "スーパー管理者",
    admin: "Admin",
    management: "管理ユーザー",
    user: "一般ユーザー",
  },

  error: {
    invalidLengthPassword: "パスワードは8文字以上32文字以下で、半角文字と数字を含めてください。",
  },
  dataNull: "全て",
  modal: {
    title: "ユーザー編集",
    createUserTitle: "ユーザー情報",
    userId: "ユーザーID",
    storeName: "ストア名",
    password: "パスワード",
    userIdPlaceholder: "ユーザーIDを入力してください",
    storeNamePlaceholder: "ストア名を選択してください",
    passwordPlaceholder: "パスワードを入力してください",
    passwordNote: "※スペースは含めないでください。また、変更後のパスワードは以前のパスワードと重複しないでください。",
    save: "保存",
    cancel: "キャンセル",
    confirmDeleteUser: "選択しているユーザー情報を削除しますか？",
    deleteUserSuccess: "ユーザー情報を削除しました。",
  },
  form: {
    btn: {
      back: "戻る",
      edit: "編集",
      cancel: "キャンセル",
      save: "保存",
    },
    userInfoItem: {
      corporationName: "法人ID",
      userNumber: "ユーザーNo.",
      fullName: "氏名",
      department: "所属部署",
      role: "権限",
      status: "ステータス",
      delete: "削除",
      confirmDelete: "本当に削除してもよろしいですか？",
    },
    userInfo: {
      userInfo: "ユーザー情報",
      add: "追加",
    },
    superAdmin: {
      role: "権限",
      superAdmin: "スーパー管理者",
      corporationId: "※法人ID",
    },
    emailAddress: {
      emailAddress: "メールアドレス",
      emailPlaceholder: "メールアドレスを入力してください",
    },
  },
}
